function normalizeAddressValue(value) {
  if (value == null) {
    return "";
  }
  return String(value).trim().toLowerCase();
}

export function getPrimaryAddressFromList(addresses) {
  if (!Array.isArray(addresses) || addresses.length === 0) {
    return null;
  }
  const primary = addresses.find((address) => {
    const rawType =
      typeof address?.type === "object" ? address.type?.name : address?.type;
    return String(rawType || "")
      .trim()
      .toUpperCase() === "PRIMARY";
  });
  return primary || addresses[0];
}

export function snapshotAddress(address) {
  if (!address) {
    return null;
  }
  return {
    address1: address.address1 || "",
    address2: address.address2 || "",
    city: address.city || "",
    state: address.state || "",
    zip: address.zip || "",
    county: address.county || "",
  };
}

export function hasAddressChanged(original, current) {
  if (!original && !current) {
    return false;
  }
  if (!original || !current) {
    return true;
  }
  const keys = ["address1", "address2", "city", "state", "zip", "county"];
  return keys.some(
    (key) =>
      normalizeAddressValue(original[key]) !==
      normalizeAddressValue(current[key])
  );
}

export function snapshotBillingAddress(profileData) {
  if (!profileData) {
    return null;
  }
  return {
    address1: profileData.pay_address_1 || "",
    address2: profileData.pay_address_2 || "",
    city: profileData.pay_city || "",
    state: profileData.pay_state || "",
    zip: profileData.pay_zip || "",
    county: profileData.pay_county || "",
  };
}

export function isBillingSameAsPrimary(profileData, primaryAddress) {
  return !hasAddressChanged(
    snapshotBillingAddress(profileData),
    snapshotAddress(primaryAddress)
  );
}

export function buildBillingUpdateFromPrimary(profileData, primaryAddress) {
  if (!profileData || !primaryAddress) {
    return null;
  }

  const have_complaint =
    profileData.complaint_detail == null || profileData.complaint_detail === ""
      ? 0
      : 1;

  let attorney_type = profileData.attorney_type;
  if (typeof attorney_type === "string") {
    attorney_type = attorney_type.split(",");
  }

  let checking_saving = profileData.checking_saving;
  if (typeof checking_saving === "string" && checking_saving) {
    checking_saving = { id: 0, name: checking_saving };
  }

  return {
    id: profileData.id,
    first_name: profileData.first_name,
    last_name: profileData.last_name,
    middle_name: profileData.middle_name,
    firm_name: profileData.firm_name,
    attorney_type,
    have_complaint,
    complaint_detail: profileData.complaint_detail,
    number_type: profileData.number_type,
    ssn_number: profileData.social_security,
    pay_to: profileData.pay_to,
    direct_deposite: profileData.direct_deposite,
    account_holder: profileData.account_holder,
    bank_name: profileData.bank_name,
    checking_saving,
    routing_number: profileData.routing_number,
    account_number: profileData.account_number,
    note: profileData.note,
    is_same_as_primary: 1,
    pay_address_1: primaryAddress.address1 || "",
    pay_address_2: primaryAddress.address2 || "",
    pay_city: primaryAddress.city || "",
    pay_state: primaryAddress.state || "",
    pay_zip: primaryAddress.zip || "",
    pay_county: primaryAddress.county || "",
    update_key: "UPDATE_DISCLOSURE_AND_BILLING",
  };
}
